import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { kubernetesTranslationRef } from '@backstage/plugin-kubernetes/alpha';

export const kubernetesTranslations = createTranslationResource({
  ref: kubernetesTranslationRef,
  translations: {
    en: () => import('./kubernetes-en'),
    es: () => import('./kubernetes-es'),
  },
});